/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tab/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import CloseAction from './CloseAction/index'
import Icon from './Icon/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Tab({
  children,
  viewPath = "/App/Account/Topbar/Tabs/QuickAccess/Tab",
  onMouseEnter,
  onMouseLeave,
  hovered,
  selected
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  onMouseEnter,
  onMouseLeave,
  hovered,
  selected
  
})
let tabNameValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'name',
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
  return (<React.Fragment
>
<button
  data-testid="Tab.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--bc-1-mwf': hovered && selected ? dtColorsNeutral700 : hovered ? dtColorsNeutral700 : selected ? dtColorsNeutral700 : dtColorsNeutral800}}
 className={`views-block ${styles.Horizontal}`}
>
<Icon
  viewPath={`${viewPath}/Icon`}
 selected={selected}
 hovered={hovered}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 cursor="pointer"
 size="large"
 weight="semibold"
 marginLeft={4}
 marginRight={4}
 letterSpacing={0.1}
 color={selected ? dtColorsWhite : dtColorsWhite}
 fontSize={dtTypographyFontsizeM}
 lineHeight="16px"
 data="tab.name"
 text={tabNameValueData}
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
 selected={selected}
/>
</button>
{children}
</React.Fragment>)
}